export class SearchResult {
    constructor(public searchResultDbId?: string) {
    }
}
